import { createContext, useCallback, useMemo, useState } from "react";

export interface AppProviderProps {
  children: React.ReactNode;
}

export const AppContext = createContext<any>({
  submittalListFilter: null,
  setSubmittalListFilter: () => {},
  materialListFilter: null,
  setMaterialListFilter: () => {},
  scheduleListFilter: null,
  setBidPackageListFilter: () => {},
  bidPackageListFilter: null,
  uiVersion: null,
  setUiVersion: () => {}
});

function AppProvider({ children }: AppProviderProps) {
  const [appState, setAppState] = useState<any>({
    submittalListFilter: null,
    materialListFilter: null,
    scheduleListFilter: null,
    bidPackageListFilter: null,
    inIframe: false,
    uiVersion: null
  });

  const setSubmittalListFilter = useCallback(
    (filter: { key: string; value: string }) => {
      setAppState({
        ...appState,
        submittalListFilter: filter
      });
    },
    [appState]
  );

  const setMaterialListFilter = useCallback(
    (filter: string) => {
      setAppState({
        ...appState,
        materialListFilter: filter
      });
    },
    [appState]
  );

  const setBidPackageListFilter = useCallback(
    (filter: string) => {
      setAppState({
        ...appState,
        bidPackageListFilter: filter
      });
    },
    [appState]
  );

  const setUiVersion = useCallback(
    (version: number) => {
      setAppState({
        ...appState,
        uiVersion: version
      });
    },
    [appState]
  );

  const contextValue = useMemo(() => {
    const inIframe = () => {
      try {
        return window.self !== window.top;
      } catch (e) {
        return true;
      }
    };
    return {
      submittalListFilter: appState.submittalListFilter,
      setSubmittalListFilter,
      materialListFilter: appState.materialListFilter,
      setMaterialListFilter,
      scheduleListFilter: appState.scheduleListFilter,
      setBidPackageListFilter,
      bidPackageListFilter: appState.bidPackageListFilter,
      inIframe: inIframe(),
      uiVersion: appState.uiVersion,
      setUiVersion
    };
  }, [
    appState.submittalListFilter,
    appState.materialListFilter,
    appState.scheduleListFilter,
    appState.bidPackageListFilter,
    appState.uiVersion,
    setSubmittalListFilter,
    setMaterialListFilter,
    setBidPackageListFilter,
    setUiVersion
  ]);

  return (
    <AppContext.Provider value={contextValue}>{children}</AppContext.Provider>
  );
}

export default AppProvider;
